import React from 'react'
import Banner from './Banner'
import TestingTypes from './TestingTypes'
import Body from './Body'

export default function Index() {
  return (
    <div>
        <Banner/>
        <Body/>
        <TestingTypes/>
    </div>
  )
}
